import { createAction } from 'redux-actions';

export type SetShowSuggestionModal = ReturnType<typeof setShowSuggestionModal>;

export const setShowSuggestionModal = createAction<boolean>('SET_SHOW_SUGGESTION_MODAL');

export const toggleShowSuggestionModal = createAction('TOGGLE_SHOW_SUGGESTION_MODAL');
